import { render, staticRenderFns } from "./EventMemorableMoment.vue?vue&type=template&id=4231e034"
import script from "./EventMemorableMoment.vue?vue&type=script&lang=js"
export * from "./EventMemorableMoment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports